import cnLang from '@/utils/i18n/cn';
import enLang from '@/utils/i18n/en';

export default function () {
    if (window.localStorage && window.localStorage.getItem('show-lang') === 'en') {
        return enLang;
    }
    return cnLang;
}
